module.exports = __webpack_public_path__ + "media/scholarships/owl-quick-tour-421f6b5c.png";